function buttons_active() {
  clear_active();
  $(".product-buttons").css("display", "block");
  $(event.target).addClass("active");
}
function magnets_active() {
  clear_active();
  $(".product-magnets").css("display", "block");;
  $(event.target).addClass("active");
}
function stickers_active() {
  clear_active();
  $(".product-stickers").css("display", "block");
  $(event.target).addClass("active");
}
function packaging_active() {
  clear_active();
  $(".product-packaging").css("display", "block");
  $(event.target).addClass("active");
}
function clear_active() {
  $(".product-buttons, .product-stickers, .product-magnets, .product-packaging").css("display", "none");
  $("#products-description-nav ul li").removeClass("active");
}